// extracted by mini-css-extract-plugin
export default {"root":"FallbackPage_root__utFQf","content":"FallbackPage_content__W7GPn"};